module.exports = __webpack_public_path__ + "img/group-logo.c5762502.svg";